import {trigger, state, style, transition, animate} from '@angular/animations';
import {
  Component, OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {MatDialog, MatSort, MatTableDataSource, Sort} from '@angular/material';
import {ToastrService} from 'ngx-toastr';
import {Message} from 'src/app/core/class/message';
import {CommonService} from 'src/app/core/services/common.service';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {DigitalContract, FilterContractDigitizationComponent} from '../filter-contract-digitization/filter-contract-digitization.component';
import { format } from 'date-fns';
import {DigitalContractService} from '../../../../../../../core/services/digital-contract.service';
import {WarningComponent} from '../../../../../../../shared/components/warning/warning.component';
import {ErrorCode} from '../../../../../../../core/constants/error-code';
import {Router} from '@angular/router';
import {NotEnoughAlertComponent} from 'src/app/shared/components/not-enough-alert/not-enough-alert.component';
import {DataSource, SelectionModel} from '@angular/cdk/collections';
import {MultiDownloadService} from '../../../../../../../core/services/multi-download.service';
import {EnumDownloadMenuName} from '../../../../../../../core/constants/common';
import {BehaviorSubject, Observable, Subscription} from "rxjs";
import {ResponsiveService} from "../../../../../../../core/services/responsive.service";
import {SCREEN_SIZE} from "../../../../../../../core/constants/screen-size";
import { SignDigitalDocumentListComponent } from '../../sign-document/sign-digital-document-list/sign-digital-document-list.component';
import { NotifyWarningCustomComponent } from 'src/app/shared/components/notify-warning-custom/notify-warning-custom.component';
import { DocumentService } from 'src/app/core/services/document.service';
import {EnumColumnTable, EnumContractUserStatus, EnumSignMethod} from 'src/app/core/constants/contract';
import { SignDigitalDocument } from '../../sign-document/sign-digital-document/sign-digital-document.component';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { finalize } from 'rxjs/operators';
import { NotifyWarningComponent } from 'src/app/shared/components/notify-warning/notify-warning.component';
import { SignDigitalProgressCloudCaComponent } from '../../sign-document/sign-digital-progress-cloud-ca/sign-digital-progress-cloud-ca.component';
import { SignDigitalProgressUsbTokenComponent } from '../../sign-document/sign-digital-progress-usb-token/sign-digital-progress-usb-token.component';
import { SignDocumentService } from 'src/app/core/services/sign-document.service';
import { SignDigitalProgressComponent } from '../../sign-document/sign-digital-progress/sign-digital-progress.component';
declare function initPluginCertificate(comp: any, contracts: any): any;

declare function signHashNormal(comp: any, base64Hash: any, sessionId: any, serialNumber: any): any;

@Component({
  selector: 'app-list-contract',
  templateUrl: './list-contract.component.html',
  styleUrls: ['./list-contract.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({height: '0px', minHeight: '0', visibility: 'hidden'})),
      state('*', style({height: '*', visibility: 'visible'})),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ListContractDigitizationComponent extends BaseComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [];
  selection = new SelectionModel<string>(true, []);
  @ViewChild('searchComponent', {static: false}) searchComponent: FilterContractDigitizationComponent;

  columnDefinitions = [
    {def: 'select', showXS: true, showSM: true, showMD: true, showMobile: true},
    {def: 'stt', showXS: true, showSM: true, showMD: true, showMobile: true},
    {def: 'name', showXS: true, showSM: true, showMD: true, showMobile: true},
    {def: 'parent', showXS: false, showSM: false, showMD: true, showMobile: false},
    {def: 'serviceTypeName', showXS: false, showSM: false, showMD: true, showMobile: false},
    {def: 'memoryStorage', showXS: false, showSM: false, showMD: false, showMobile: false},
    {def: 'effectiveDate', showXS: false, showSM: false, showMD: false, showMobile: false},
    {def: 'expiredDate', showXS: false, showSM: false, showMD: false, showMobile: false},
    {def: 'createdBy', showXS: false, showSM: false, showMD: false, showMobile: false},
    {def: 'status', showXS: false, showSM: false, showMD: false, showMobile: false},
    {def: 'action', showXS: true, showSM: true, showMD: true, showMobile: true}
  ];

  paginate: Paginate;

  dataSource: DocumentDataSource;

  sorts: object;

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  reloadFilter: boolean;

  featureStatus: boolean;

  statusBackup: boolean;

  contractDigitalFilter = {
    capacityContractsActive: 0,
    capacityContractsInactive: 0,
    totalContractsActive: 0,
    totalContractsInactive: 0
  };
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  pageIndex: {
    currentPage: number,
    pageSize: number
  };
  public documentCount = 0;
  isSigningLotUsb: Boolean = true;
  userCancel: Boolean = false;
  expiredBatch: Boolean = false;
  public processedPercent = 0;
  waitSignDocsCount: number = 0

  constructor(
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private toast: ToastrService,
    private router: Router,
    private digitalContractService: DigitalContractService,
    private downloadService: MultiDownloadService,
    private responsiveService: ResponsiveService,
    private documentService: DocumentService,
    private signDocumentService: SignDocumentService,
  ) {
    super(commonService, message);
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.dataSource = new DocumentDataSource();
    this.dataSource.data.subscribe(() => {
      this.updateSignButtonsStatus();
    });

  }

  ngOnInit() {
    const digitalFeature = JSON.parse(localStorage.getItem('featureStatus'));
    digitalFeature.map(item => {
      if (item.permission === 10) {
        this.featureStatus = item.status;
        this.statusBackup = item.statusBackup;
      }
    });
    this.digitalContractService.checkBackup().subscribe(res => {
      if (res.message === 'OK') {
        this.statusBackup = false;
      } else {
        this.statusBackup = true;
      }
    });
    this.columnDefinitions.forEach(item => {
      this.displayedColumns.push(item.def);
    });

    this.documentService.signDigitalUpdateAction.subscribe((result) => {
      // console.log("result vao ne isStopSignLot: " + JSON.stringify(result.isStopSignSlot ? result.isStopSignSlot : "null"));
      // console.log(result)
      if (!result || !result.res) {
        this.isSigning = false;
        this.isSigningLotUsb = false;
        return;
      }
      this.isSigningLotUsb = !result.isStopSignSlot;
      const rs = result.res;
      // if (this.expiredBatch) {
      // 	this.expiredBatch = false;
      // }
      // console.log("phan hoi ne: " + JSON.stringify(result));

      if (result.expired) {
        this.isSigningLotUsb = false;
        this.userCancel = true;
        this.expiredBatch = true;
        // this.documentService.stopSign().subscribe();
        // return ;
      }
      rs.data && rs.data.info && rs.data.info.details && rs.data.info.details.forEach(ct => {
        if (ct.status === DocumentService.STATUS_DONE) {
          const index = this.dataSelected.findIndex(data => data.id === ct.contractId);
          if (index !== -1) {
            this.dataSelected.splice(index, 1);
          }
        }
      });

      this.signedContract.forEach(el => {
        const index = this.dataSelected.findIndex(data => data.id === el);
        if (index !== -1) {
          this.dataSelected.splice(index, 1);
        }
      });

      this.signStatus = result.signStatus;
      const percent = result.percent;
      const isStopSignSlot = result.isStopSignSlot;

      if (isStopSignSlot) {
        this.isSigning = false;
      } else {
        this.isSigning = true;
      }

      if (rs && rs.data) {
        if (!rs.data.info || !rs.data.info.details || rs.data.info.details.length === 0) {
          return;
        }

        // set value of progress.
        this.documentCount = rs.data.info.details.length;

        // update progress of signed document.
        this.processedPercent = percent;
      }

      // Check there're signing before.
      if (this.signStatus === DocumentService.SLOT_SIGN_FINISH) {
        if (this.typeCertificate === EnumSignMethod.CLOUD_CA) {
          // do work here
          if (this.dialogRef.componentInstance == null || this.dialogRef.componentInstance.isDisabledStopSignButton == false) {
            if (rs.data.info.success != false) {
              this.dialogRef.close();
              this.dialog.open(NotifyWarningComponent, {
                // data: "Lô ký duyệt của bạn đã xác nhận ký trên ứng dụng Ký số từ xa, hệ thống sẽ tiếp thực hiện các bước để xử lý hợp đồng  và sẽ gửi lại thông báo sau khi hoàn thành. Bạn có thể chọn lô tiếp theo để thực hiện phê duyệt."
                data: this.message.getMessage('messages.sign_batch_mysign_complete'),
              });
              this.dataSelected = [];
            }
          }
        }
        setTimeout(() => {
          this.signStatus = null;
          this.isSigning = false;
          this.isSigningLotUsb = false;

          // reload page when finish sign
          this.searchComponent.searchContract();

        }, 1000);
      } else if (this.signStatus === DocumentService.SLOT_SIGN_NO_ACTION || this.signStatus === DocumentService.SLOT_SIGN_STOP) {
        this.isSigning = false;
        this.signStatus = null;
        this.isSigningLotUsb = false;
      }
    });

    // call get slot info.
    this.getSlotInfo(false);
  }

  ngOnDestroy() {
    this.downloadService.clearData();
  }

  getDataTable($event: any) {
    if ($event === null) {
      // filter bắt đầu load: xóa dữ liệu cũ để footer skeleton hiển thị thay thế
      this.dataSource.setData([]);
      return;
    }
    const dataSource = $event.pageData.content;
    console.log('dataSource1', dataSource);
    if (dataSource.length === 0 && $event.pageData.total > 0) {
      this.paginate.currentPage = 0;
      return;
    }
    let formatWay = 'DD/MM/YYYY';
    dataSource.map(item => {
      item.effectiveDate = item.effectiveDate ? format(format(item.effectiveDate, 'MMM DD, YYYY HH:mm:ss A'), formatWay) : '';
      item.expireDate = item.expireDate ? format(format(item.expireDate, 'MMM DD, YYYY HH:mm:ss A'), formatWay) : '';
    });

    this.dataSource.setData(dataSource);
    this.waitSignDocsCount = 0
    dataSource.map(item => {
      if (item.status === 1) {
        this.waitSignDocsCount++;
      }
    })
    
    console.log('this.dataSource', this.dataSource);
    // this.dataSource.sort = this.sort;
    this.contractDigitalFilter = $event.contractDigitalFilter;
    this.pageIndex = {
      pageSize: $event.pageData.pageable.size,
      currentPage: $event.pageData.pageable.page
    };
    this.paginate = {
      pageSize: $event.pageData.pageable.size,
      currentPage: $event.pageData.pageable.page,
      totalRow: $event.pageData.total,
      totalPage: Math.ceil($event.pageData.total / $event.pageData.pageable.size),
      totalPageArray: this.counter(Math.ceil($event.pageData.total / $event.pageData.pageable.size), 1),
      no: this.counter($event.pageData.pageable.size, $event.pageData.pageable.page * $event.pageData.pageable.size + 1)
    };
  }

  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    }
    else   if (this.mediaBreakpoint === SCREEN_SIZE.MD ) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMD)
        .map(cd => cd.def);
    }
    else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
  }
  ngAfterViewInit(page: number = 0) {

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  onChangePage(e: any) {
    this.paginate.currentPage = e.page ? e.page : 0;
    this.paginate.pageSize = e.pageSize;
  }

  onChangeSort(e: Sort) {
    this.sorts = null;
    if (e.direction === '') {
      return;
    } else if (e.active === 'name') {
      this.sorts = {code: e.direction.toUpperCase()};
    } else {
      this.sorts = {[e.active]: e.direction.toUpperCase()};
    }
  }

  convertCapacity(totalCapacity: number) {
    const capacity = totalCapacity / 1024 / 1024 / 1024;
    if (capacity >= 0.1) {
      return (capacity.toFixed(3)) + 'GB';
    } else {
      return ((totalCapacity / 1024 / 1024).toFixed(3)) + 'MB';
    }
  }

  actionInContract(action: string, id?: string) {
    switch (action) {
      case 'create':
        this.digitalContractService.checkBackup().subscribe(res => {
          if (res.message === 'OK') {
            this.statusBackup = false;
            this.router.navigateByUrl(`/home-enterprise/digital-contract/${action}`);
          } else {
            this.statusBackup = true;
            this.toast.error(res.message);
          }
        });
        break;
      case 'update':
        this.digitalContractService.checkBackup().subscribe(res => {
          if (res.message === 'OK') {
            this.statusBackup = false;
            this.router.navigateByUrl(`/home-enterprise/digital-contract/${id.replace(/=/g, '')}/${action}`);
          } else {
            this.statusBackup = true;
            this.toast.error(res.message);
          }
        });
        break;
      case 'view':
        this.router.navigateByUrl(`/home-enterprise/digital-contract/${id.replace(/=/g, '')}/${action}`);
        break;
    }
  }

  downloadContract(contract) {
    if (contract.id) {
      this.digitalContractService.downloadContract(contract.id).subscribe(res => {
        if (res.type === 'application/json') {
          this.digitalContractService.downloadContractFail(contract.id).subscribe(error => {
            if (error) {
              this.toast.error(error.message);
            }
            return;
          });
        } else if (res) {
          if (window.top.navigator.msSaveOrOpenBlob) {
            // Store Blob in IE
            window.top.navigator.msSaveOrOpenBlob(res, contract.name + '.zip');
          } else {
            // Store Blob in others
            const tA = document.body.appendChild(document.createElement('a'));
            tA.href = window.URL.createObjectURL(res);
            tA.download = contract.code + ' - ' + contract.name + '.zip';
            tA.style.display = 'none';
            tA.click();
            tA.parentNode.removeChild(tA);
          }
        }

      });
    }
  }

  multiDownload() {
    this.downloadService.setData({
      contractIds: this.dataSelected.map(item => item.id),
      menuContract: EnumDownloadMenuName.LIST_CONTRACT,
      isDigital: true,
    });
  }

  activeContract(contract) {
    this.digitalContractService.activeContract(contract.id).subscribe(res => {
      if (res && res.success) {
        this.digitalContractService.reloadFilter.next(true);
        this.toast.success(this.message.getMessage('messages.active_contract_success'));
      } else {
        this.reloadFilter = false;
        if (res && res.code === ErrorCode.CreateUpdateDigitalContract6) {
          const dialogConfirm = this.dialog.open(NotEnoughAlertComponent, {
            width: '30%'
          });
          this.reloadFilter = false;
        } else {
          this.toast.error(res.message);
        }
      }
      this.digitalContractService.reloadFilter.next(false);
    });
  }

  deleteContract(contract: DigitalContract) {
    const dialogConfirm = this.dialog.open(WarningComponent, {
      data: this.commonService.format(this.message.getMessage('messages.delete_contract'), contract.code + ' - ' + contract.name),
      width: '40%'
    });
    dialogConfirm.afterClosed().subscribe(ref => {
      if (ref) {
        this.digitalContractService.deleteContract(contract.id).subscribe(res => {
          if (res && res.success) {
            if ((this.paginate.totalRow - 1) % this.paginate.pageSize === 0 && this.paginate.currentPage > 0) {
              this.paginate.currentPage -= 1;
            }
            this.reloadFilter = true;
            this.toast.success(this.message.getMessage('messages.delete_success'));
          } else {
            this.toast.error(res.message);
            this.reloadFilter = false;
          }
        });
      }
      this.reloadFilter = false;
    });
  }

  // isAllSelected() {
  //   const selecteds = this.selection.selected;
  //   const dataSourceIds = this.dataSource.data.map(d => d.id);
  //   const intersectionArr = dataSourceIds.filter(data => selecteds.includes(data));
  //   return intersectionArr.length === dataSourceIds.length;
  // }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  // masterToggle() {
  //   const dataSourceIds = this.dataSource.data.map(ds => ds.id);
  //   this.isAllSelected() ?
  //     this.selection.deselect(...dataSourceIds) :
  //     this.selection.select(...dataSourceIds);
  // }

  @BlockUI() blockUI: NgBlockUI;
  private signedContract: Array<string> = [];
  private digitalCertificateId: any;
  private serialNumberChoose: any;
  private digitalCertificateDetailId: any;
  private contractsForSign: any;
  private sign: any = {};
  private sessionId = null;
  private signTransactionId: any;
  private isDisableNextButton = false;
  public isSigning = false;
  public countCheck: number = 0;
  public countContract: number = 0;
  signLotImage: Boolean;
  imageBase64: any;
  dataSelected: any[] = [];
  typeCertificate = EnumSignMethod.SIGN_SERVER;
  fileUpload: File;
  dialogRef: any;
  dialogSign: any;
  dialogProgress: any;
  signStatus: any;
  checkAll: boolean;

  private openSignDocumentList(signOption: string) {

    if (this.signedContract.length > 0) {
      this.updateSignButtonsStatus();
    }
    console.log(this.selection);
    
    if (signOption !== SignDigitalDocumentListComponent.SIGN_ALL && !this.dataSelected.some(d => d.status === 1)) {
      const popup = this.dialog.open(NotifyWarningCustomComponent, {
        width: '600px',
        data: {
          content: this.commonService.format(this.message.getMessage('messages.reject_sign_by_lot')),
        }
      });
    } else {
      const popup = this.dialog.open(SignDigitalDocumentListComponent, {
        width: '50vw',
        data: {
          signOption,
          slotDocuments: new BehaviorSubject<Document[]>(this.dataSelected),
          filterSignAll: {status: 1}
        }
      });
      const component = this;
      popup.componentInstance.actions.subscribe(ac => {
        let datasource = null;

        switch (ac) {
          case SignDigitalDocumentListComponent.CONFIRM_ACTION:
            datasource = popup.componentInstance.dataSource;
            popup.close();
            break;
          case SignDigitalDocumentListComponent.CLOSE_ACTION:
            // if (this.goFrom && this.goFrom === 'signBatch') {
            //   localStorage.removeItem('signBatchContracts');
            // }
            popup.close();
            popup.componentInstance.actions.unsubscribe();
            break;
        }

        if (!datasource) {
          return;
        }

        datasource = datasource.map(_doc => {
          const found = this.signedContract.find(el => el == _doc.id);
          if (found === undefined) {
            return _doc;
          }

        });

        const popup2 = this.dialog.open(SignDigitalDocument, {
          width: '40%',
          data: {
            type: SignDigitalDocument.SIGN_SLOT,
            document: datasource
          }
        });

        popup2.componentInstance.actions.subscribe((ac) => {

          const imageSignSystem = this.documentService.systemSignImage.value || null;
          switch (ac) {
            case SignDigitalDocument.CONFIRM_ACTION:
              const slotIds = [];
              // get document ids.
              datasource.forEach(doc => {
                slotIds.push(doc.id);
              });
              this.typeCertificate = popup2.componentInstance.selectedCert.typeCertificate;
              const idDetail = popup2.componentInstance.selectedCert.idDetail;
              this.digitalCertificateId = popup2.componentInstance.selectedCert.id;
              this.serialNumberChoose = popup2.componentInstance.selectedCert.serialNumber;
              this.signLotImage = popup2.componentInstance.selectedCert.imagePath ? true : false;
              this.imageBase64 = popup2.componentInstance.selectedCert.imagePath;
              // submit sign to server.
              if (this.typeCertificate == EnumSignMethod.SIGN_SERVER) {
                this.documentService.submitSignedDocuments(slotIds, imageSignSystem)
                  .subscribe(rs => {
                    if (rs.data) {
                      this.openSigningProgressPopup();
                    }

                    // else display error message at top right.
                  });
              } else if (this.typeCertificate == EnumSignMethod.CLOUD_CA) {

                
                  this.blockUI.start()
                  this.documentService.submitSignDigitalMultiCloudCa(slotIds, idDetail, imageSignSystem)
                  .pipe(finalize(()=>{
                    this.blockUI.stop();
                    this.searchComponent.searchContract();
                  }))
                  .subscribe(rs => {
                    if (rs.success) {
                      this.openSigningProgressCloudCaPopup();
                    } else {
                      this.toast.error(rs.message);
                      // if (rs.code == ErrorCode.isContractProcess) {
                      //   this.toastr.error("Dang co lo xu ly, vui long thu lai sau it phut")
                      // }
                    }

                    // else display error message at top right.
                  });
                
              } else if (this.typeCertificate == EnumSignMethod.SIGN_USB_TOKEN) {
                //TODO: handler method sign multi cloud ca
                this.digitalCertificateDetailId = idDetail;

                const contracts = datasource.map(_doc => {
                  const found = this.signedContract.find(el => el == _doc.id);
                  if (found === undefined) {
                    return {
                      nameContract: _doc.contractName,
                      numberOfFiles: _doc.contractAttachments.length
                    };
                  }
                });
                this.contractsForSign = datasource;

                this.handleB64Image(this.imageBase64);

                initPluginCertificate(this, contracts);
              }

              popup2.close();
              // this.blockUI.reset();
              // this.blockUI.start('');
              popup2.componentInstance.actions.unsubscribe();
              break;
            case SignDigitalDocument.CLOSE_ACTION:
              popup2.close();
              popup2.componentInstance.actions.unsubscribe();
              this.searchComponent.searchContract();
              break;
            default:
              break;
          }//
        });
      });
    }
  }

  async handleB64Image(base64) {
    if (base64 == null || base64 == undefined) {
      return;
    }
    const imageDataBlob = this.commonService.b64toBlob(base64);
    const blobUrl = URL.createObjectURL(imageDataBlob);
    if (blobUrl) {
      await fetch(blobUrl)
        .then(r => r.blob())
        .then(blobFile => {
          this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
        });
    }
  }
  
  openSigningProgressCloudCaPopup() {
    this.isSigning = false;
    const popup = this.dialog.open(SignDigitalProgressCloudCaComponent, {
      width: '50vw',
      data: {
        isFinished: this.signStatus === DocumentService.SLOT_SIGN_FINISH
      }
    });

    this.dialogRef = popup;

    popup.componentInstance.actions.subscribe(ac => {
      // close popup.
      switch (ac) {
        case SignDigitalProgressCloudCaComponent.STOP_ACTION:
        case SignDigitalProgressCloudCaComponent.FINISH_ACTION:
          // replace background by sign slot & sign all
          // reload data.
          this.isSigning = false;
          popup.close();
          this.searchComponent.searchContract();
          
          break;
        case SignDigitalProgressCloudCaComponent.CLOSE_ACTION:
          this.isSigning = true;
          popup.close();
          this.searchComponent.searchContract();
          this.getSlotInfo(true);
          break;
        default:
          break;
      }
    });
  }

  openSigningProgressUsbTokenPopup() {
    this.isSigning = false;
    const popup = this.dialog.open(SignDigitalProgressUsbTokenComponent, {
      width: '50vw',
      data: {
        isFinished: this.signStatus === DocumentService.SLOT_SIGN_FINISH
      }
    });

    popup.componentInstance.actions.subscribe(ac => {
      // close popup.
      switch (ac) {
        case SignDigitalProgressUsbTokenComponent.STOP_ACTION:
        case SignDigitalProgressUsbTokenComponent.FINISH_ACTION:
          // replace background by sign slot & sign all
          // reload data.
          this.isSigning = false;
          popup.close();
          this.searchComponent.searchContract();
          break;
        case SignDigitalProgressUsbTokenComponent.CLOSE_ACTION:
          this.isSigning = true;
          popup.close();
          this.searchComponent.searchContract();
          break;
        default:
          break;
      }
    });
  }
  
  async processSignLotUsingUsbToken() {
    if (this.serialNumberChoose !== this.sign.serialNumber) {
      this.showErrMsgTransle('messages.select_certificate_failed');
      return;

    }

    // init lo usb token
    this.blockUI.reset();
    this.blockUI.start('');
    const rs = await this.documentService.usbTokenInitSignGroup({
      contracts: this.contractsForSign.map(contract => contract.id),
      digitalCertificateDetailId: this.digitalCertificateDetailId,
      certificate: this.sign.certRawdata,
      type: 5
    }).toPromise();
    if (rs && rs.success) {
      this.blockUI.stop();
      this.openSigningProgressUsbTokenPopup();
      this.isSigningLotUsb = true;
      this.userCancel = false;
      // this.cancelCalls = [];

      let result = true;

      for await (const contract of this.contractsForSign) {

        const found = this.signedContract.find(el => el == contract.id);
        console.log(found);
        if (found === undefined) {
          if (rs.data[contract.id] && !this.userCancel) {
            // result = await this.signContract(contract, rs.data[contract.id])
            result = await this.signBatchContracts(contract, rs.data[contract.id]);
          } else {
            continue;
          }
        }
      }

      if (this.userCancel) {
        await this.documentService.cancelSignBatchDigital().toPromise();
      }

    } else {
      this.blockUI.stop();
    }
  }

  handleSingingProcess() {

    if (this.typeCertificate == EnumSignMethod.SIGN_SERVER) {
      this.openSigningProgressPopup();
    }

    if (this.typeCertificate == EnumSignMethod.CLOUD_CA) {
      this.openSigningProgressCloudCaPopup();
    }

    if (this.typeCertificate == EnumSignMethod.SIGN_USB_TOKEN) {
      this.openSigningProgressUsbTokenPopup();
    }

  }

  async signBatchContracts(contract, signPositions) {
    const mainContractAttachmentsNew = [];
    let isSuccess = true;

    if (!this.isSigningLotUsb) {
      console.log('stop signing call cancel sign');
      this.signDone(contract, mainContractAttachmentsNew, false, null);
      return;
    }

    // if (this.userCancel) {
    // 	this.cancelCalls.push(this.signDone(contract, mainContractAttachmentsNew, false, null));
    // 	return;
    // }

    let attachmentSignPosMap = new Map();
    let loopNo = 0;
    contract.contractAttachments.forEach(attachment => {
      let signPos = signPositions.filter(el => el.fileId == this.decodeId(attachment.id));
      attachmentSignPosMap.set(attachment, signPos);
      if (signPos.length >= loopNo) {
        loopNo = signPos.length;
      }
    });

    let prevData = null;

    let lstDto = [];
    let rs = null;
    if (!this.isSigningLotUsb) {
      await this.signDone(contract, mainContractAttachmentsNew, false, null);
      return;
    }
    const imageSignSystem = this.documentService.systemSignImage.value || null;
    attachmentSignPosMap.forEach((v, k) => {
      let signPos = v[0];
      let dto = {
        contractId: contract.id,
        digitalCertificateId: this.digitalCertificateId,
        digitalCertificateDetailId: this.digitalCertificateDetailId,
        certificate: this.sign.certRawdata,
        path: null,
        fileId: null,
        position: null,
        signPositions: null,
        oldPath: null,
        id: null,
        idDetail: null,
        enterpriseId: null,
        typeCertificate: null,
        serialNumber: null,
        image: null,
        base64Image: imageSignSystem,
        certRawdata: null,
      };
      dto.path = k.path;
      dto.fileId = signPos.fileId;
      dto.position = signPos;
      dto.signPositions = v;
      dto.typeCertificate = '1';
      if (prevData) {
        dto.oldPath = prevData.filter(data => data.fileId == k.id)[0].path;
      }

      if (this.signLotImage) {
        dto.contractId = contract.id;
        dto.digitalCertificateId = this.digitalCertificateId;
        dto.digitalCertificateDetailId = this.digitalCertificateDetailId;
        dto.id = this.digitalCertificateId;
        dto.idDetail = this.digitalCertificateDetailId;
        dto.enterpriseId = localStorage.getItem('enterpriseId');
        dto.typeCertificate = '1';
        dto.serialNumber = this.sign.serialNumber;
        dto.certificate = this.sign.certRawdata;
        dto.certRawdata = this.sign.certRawdata;
        dto.position = JSON.stringify(signPos);
        dto.signPositions = JSON.stringify(v)
        dto.base64Image = imageSignSystem;
      }
      lstDto.push(dto);
    });
    // attachmentSignPosMap.forEach((v, k) => {
    // 	let signPos = v[index];
    // 	console.log(k, signPos)
    // })
    // attachmentSignPosMap.forEach((v, k) => {
    // 	console.log(k)
    // })
    // console.log("chuan bi hash: ", this.isSigningLotUsb)
    if (!this.signLotImage) {
      rs = await this.documentService.createMultiHashNoImage({models: lstDto}, true).toPromise();
    } else {
      rs = await this.documentService.createMultiHashImage(lstDto, true).toPromise();
    }

    // console.log("res hash: " + JSON.stringify(rs));

    // if (this.expiredBatch) {
    // 	await this.signDone(contract, mainContractAttachmentsNew, false, rs ? rs.data ? rs.data.signTransactionId : null : null);
    // 	return;
    // }

    if (rs && !rs.success) {
      isSuccess = false;
      await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
      return isSuccess;
    }
    if (!rs) {
      isSuccess = false;
      await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
      return isSuccess;
    }
    if (rs && rs.data) {
      prevData = rs.data;
      rs.data.forEach(el => {
        mainContractAttachmentsNew.push({path: el.path, id: el.fileId});
      });
    }

    let sig = null;

    try {

      sig = await signHashNormal(this, JSON.stringify(rs.data), this.sessionId, this.sign.serialNumber);
    } catch (err) {
      isSuccess = false;
      this.userCancel = true;
      // console.log("sign return js -> ts ", sig)
      // await this.documentService.cancelSignBatch().toPromise()
      return;
    }

    if (this.expiredBatch) {
      this.userCancel = true;
      sig = null;
    }

    // if (this.expiredBatch) {
    // 	await this.signDone(contract, mainContractAttachmentsNew, false, rs ? rs.data ? rs.data.signTransactionId : null : null);
    // 	return;
    // }

    if (sig) {
      let lstSignDto = [];
      sig.forEach(signature => {
        let signDTO = {
          path: rs.data.filter(o => o.fileId == signature.fileId)[0].path,
          signPdf: rs.data.filter(o => o.fileId == signature.fileId)[0].signPdf,
          contractId: contract.id,
          signature: signature.signatureBase64,
          fileId: this.decodeId(signature.fileId),
          position: signPositions.filter(pos => pos.fileId == this.decodeId(signature.fileId))[0],
          signPositions: signPositions,
        };
        lstSignDto.push(signDTO);
      });
      const resSign = await this.documentService.signBatchUsb(lstSignDto, true).toPromise();

      if (resSign && !resSign.success) {
        isSuccess = false;
        await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
        return isSuccess;
      }
      if (!resSign || !resSign.data) {
        isSuccess = false;
        await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
        return isSuccess;
      }
      if (resSign && resSign.success) {
        if (!this.isSigningLotUsb || this.expiredBatch) {
          console.log('stop signing call cancel sign');
          isSuccess = false;
          await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
          return;
        }
        await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
      }

    } else {
      isSuccess = false;

      await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
      return isSuccess;
    }

    // index++;


    return isSuccess;
  }

  openSigningProgressPopup() {
    this.isSigning = false;
    const popup = this.dialog.open(SignDigitalProgressComponent, {
      width: '50vw',
      data: {
        isFinished: this.signStatus === DocumentService.SLOT_SIGN_FINISH
      }
    });

    popup.componentInstance.actions.subscribe(ac => {
      // close popup.
      switch (ac) {
        case SignDigitalProgressComponent.STOP_ACTION:
        case SignDigitalProgressComponent.FINISH_ACTION:
          // replace background by sign slot & sign all
          // reload data.
          this.isSigning = false;
          popup.close();
          this.searchComponent.searchContract();
          break;
        case SignDigitalProgressComponent.CLOSE_ACTION:
          this.isSigning = true;
          popup.close();
          this.searchComponent.searchContract();
          break;
        default:
          break;
      }
    });
  }
  
  public updateSignButtonsStatus() {
    if (this.dataSource == null
      || this.dataSource.data == null
      || this.dataSource.data.value == null
      || this.dataSource.data.value.length === 0) {
      return;
    }

    this.countCheck = 0;
    this.countContract = 0;
    this.dataSource.data.value.forEach(data => {
      if (data.checked) {
        this.countCheck++;
      }
      this.countContract++;

      const index = this.dataSelected.findIndex(item => item.id === data.id);
      if (index !== -1 && !data.checked) {
        this.dataSelected.splice(index, 1);
      } else if (index === -1 && data.checked) {
        const found = this.signedContract.find(el => el == data.id);
        if (found === undefined) {
          this.dataSelected.push(data);
        }
      }
      for (let i = 0; i < this.signedContract.length; i++) {
        const tmp = this.dataSelected.findIndex(item => item.id === this.signedContract[i]);
        if (tmp !== -1) {
          this.dataSelected.splice(tmp, 1);
        }
      }

    });

    // check all enable.
    if (this.countCheck === this.countContract && this.countCheck > 0) {
      this.checkAll = true;
    } else {
      this.checkAll = false;
    }
  }

  public onSelectionChange() {
    this.updateSignButtonsStatus();
  }

  showErrMsgTransle(msg) {
    this.toast.error(this.message.getMessage(msg));
  }

  showErrMsgTransleFormat(msg) {
    this.toast.error(this.message.getMessage(msg));
  }

  public checkAllDocument() {
    this.dataSource.data.value.forEach(data => {
      data.checked = this.checkAll;
    });

    this.updateSignButtonsStatus();
  }

  private getSlotInfo(hasPreviousData) {
    // enable calling flag.
    // this.isReadyToCalling = false;

    this.documentService.getDigitalSlotStatus(hasPreviousData);
  }

  openSignSlot(){
    this.openSignDocumentList(SignDigitalDocumentListComponent.SIGN_SLOT);
  }

  openSignAll(){
    this.openSignDocumentList(SignDigitalDocumentListComponent.SIGN_ALL);
  }

  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
      return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }

  async signDone(contract, mainContractAttachmentsNew, isSuccess, signTransactionId) {
    // return new Promise((resolve, reject) => {
    const data = {
      signTransactionId: null,
      userCancel: false,
      signMethod: this.typeCertificate,
      contractId: contract.id,
      mainContractAttachments: mainContractAttachmentsNew,
      certificate: this.sign.certificate.certBase64,
      digitalCertificateDetailId: this.digitalCertificateDetailId
    };
    if (isSuccess) {
      //done sign
      // this.isCallDone = true;
      console.log('call done sign');
      console.log('push signedcontract: ' + contract.id);
      this.signedContract.push(contract.id);
      const res = await this.signDocumentService.signDoneDigital(data, true).toPromise();
      // .subscribe(res => {
      if (res && res.data) {
        // return isSuccess
      } else {
        console.log('done sign fail');
        const index = this.signedContract.findIndex(el => el === contract.id);
        if (index !== -1) {
          this.signedContract.splice(index, 1);

        }

      }
      // else {
      //   this.isCallDone = false;
      // }
      // },
      // err => {
      //   console.error(err)
      //   this.message.getMessage('messages.sign_fail');
      //   // isSuccess = false;
      // })
    } else {
      console.log('call cancel sign');
      data.userCancel = true;
      const res = await this.signDocumentService.signCancel(data, true).toPromise();
      console.log('cancel res ', JSON.stringify(res));
    }
    if (isSuccess) {
      // resolve(isSuccess);
    } else {
      // reject(isSuccess)

    }

    // })
  }

  setSessionId(value) {
    this.sessionId = value;
  }

  setCertData(value) {
    this.sign.certificate = value;
  }

  setCertRawdata(value) {
    this.sign.certRawdata = value;
  }

  setSerialNumber(value) {
    this.sign.serialNumber = value;
  }

  setIssuedTo(value) {
    this.sign.issuedTo = value;
  }

  setDistinguishedName(value) {
    this.sign.distinguishedName = value;
  }

  setTaxCode(value) {
    this.sign.taxCode = value;
  }

  setIssuedBy(value) {
    this.sign.issuedBy = value;
  }


  setActiveDate(value) {
    this.sign.activeDate = new Date(value);
  }

  setExpireDate(value) {
    this.sign.expireDate = new Date(value);
  }

  setActiveContinueButton() {
    this.isDisableNextButton = false;
  }

  createTransaction(contract) {

    //can them isConfirmBCT
    this.blockUI.reset();
    this.blockUI.start('');
    if (contract.isConfirmBCT) {

      const body = {
        signMethod: EnumSignMethod.SIGN_USB_TOKEN,
        contractId: contract.id,
        // signPositions: this.signImages
      };
      this.documentService.createTimestampMoney(body).subscribe(
        res => {
          this.blockUI.stop();
          if (res && !res.success) {
            if (res.code === ErrorCode.NotEnoughMoneyTimestamp) {
              this.showErrMsgTransle('digital_certificate_management.out_of_money_timestamp');
              // this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
            } else {
              this.toast.error(res.message);
            }
          } else {
            this.signTransactionId = res.data;
            // this.onClickSignButton()
          }
        }
      );
    } else {
      // this.signImages = imagePreSort;
      this.blockUI.stop();
      // this.onClickSignButton();

    }
  }
}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: [];
  no: [];
}

export class DocumentDataSource extends DataSource<DigitalContract> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<DigitalContract[]>([]);

  constructor() {
    super();
  }


  setData(data: DigitalContract[]) {

    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<DigitalContract[]> {
    return this.data.asObservable();
  }

  disconnect(): void {
    this.data.complete();
  }
}
